import { AttachmentFullViewState } from 'owa-attachment-full-data';

export default function shouldShowProgressIndicator(
    attachmentViewState: AttachmentFullViewState
): boolean {
    return (
        attachmentViewState.actionCompletePercent > 0 &&
        attachmentViewState.actionCompletePercent <= 1
    );
}
